const angular = require('angular');
const app = angular.module('learn-resources');
/**
 * Zoom Integrations Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('ZoomIntegrate', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {

  return $resource(appConfiguration.apiUrl + '/v3/zoomintegrate/:subresource/:option/:subsubresource', null, {
    create: {params: {subresource: ''}, method: 'POST', isArray: false},
    exists: {params: {subresource: 'exists'}, method: 'GET', isArray: false},
    existsWithUser: {params: {subresource: 'exists', option: 'user'}, method: 'GET', isArray: false},
    checkZoomUser: {params: {subresource: 'user'}, method: 'GET', isArray: false},
    manualParticipantSync: {params: {subresource: 'participant-sync'}, method: 'POST', isArray: false},
    getZoomSummary: {params: {subresource: 'meeting-summary'}, method: 'GET', isArray: false},
  });
}]);